import React from 'react';

const VariantToggleSection = ({ enableVariants, setEnableVariants }) => {
  return (
    <div className="sm:col-span-6">
      <div className="flex items-center justify-between py-4 border-t border-gray-200 mt-6">
        <div>
          <h3 className="text-base font-medium text-gray-900">Variantes de produit</h3>
          <p className="text-sm text-gray-500">Activez cette option si votre produit existe en plusieurs variantes (tailles, couleurs, etc.)</p>
        </div>
        <button
          type="button"
          className={`relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540] ${enableVariants ? 'bg-[#174540]' : 'bg-gray-200'}`}
          role="switch"
          aria-checked={enableVariants}
          onClick={() => setEnableVariants(!enableVariants)}
        >
          <span className="sr-only">Activer les variantes</span>
          <span
            className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ${enableVariants ? 'translate-x-5' : 'translate-x-0'}`}
          />
        </button>
      </div>
    </div>
  );
};

export default VariantToggleSection;